import type { AnyFunction } from '../../../../types.tsx';
import type { DeferredType } from './deferred.types.tsx';

/**
 * Inline lightweight implementation of jQuery deferreds to maintain compatibility with `@atlassian/atlassian-connect-js`.
 * Hopefully we won't need this once `@atlassian/atlassian-connect-js` actually starts accepting promises in the content
 * resolver.
 * @constructor
 */
export function Deferred<T>(this: DeferredType<T>) {
	// eslint-disable-next-line @typescript-eslint/no-this-alias
	const that = this;

	that._promise = new Promise((resolve, reject) => {
		that.resolve = resolve;
		that.reject = reject;
	});
}

Deferred.prototype.then = function then(callbackResolve: AnyFunction, callbackReject: AnyFunction) {
	this._promise.then(callbackResolve, callbackReject);
	return this;
};

Deferred.prototype.finally = function _finally(callback: AnyFunction) {
	this._promise.finally(callback);
	return this;
};

Deferred.prototype.done = function done(callback: AnyFunction) {
	this._promise.then(callback);
	return this;
};

Deferred.prototype.fail = function fail(callback: AnyFunction) {
	this._promise.catch((error: Error) => {
		// This looks dodgy, but `@atlassian/atlassian-connect-js` uses the second parameter as the actual error and ignores
		// the first.
		callback(error, error);
	});
	return this;
};

Deferred.prototype.always = function always(callback: AnyFunction) {
	this._promise.finally(callback);
	return this;
};
